module.exports = "/assets/dist/images/relaycars_logo.jpg?7ac4b0ac0ef70bd0d4fd354cabc7137e";